export const CALCULATION_METHOD_SPECIFIC_COMPONENT_IDENTIFICATION =
  'Specific Component Identification'
export const CALCULATION_METHOD_AVERAGE_BILL_OF_MATERIALS =
  'Average Bill of Materials (ABOM)'
export const CALCULATION_METHOD_FIXED_FACTOR = 'Fixed Factor Calculation Method'
export const CALCULATION_METHOD_OTHER = 'Other'

export const REPORT_STATUS_PUBLISHED = 'published'

export const FPR_SYSTEM_FIELDS = {
  SKU: 'SKU',
  SUPPLIER: 'Supplier',

  QTY_MANUFACTURED: 'Quantity Manufactured in Canada',
  QTY_IMPORTED: 'Quantity Imported',
  QTY_PLACED_ON_MARKET: 'Quantity Placed on Market',
  QTY_WASTE_GENERATED_AT_PREMISES: 'Quantity Waste Generated at Premises',
  QTY_COLLECTED_AT_END_OF_LIFE: 'Quantity Collected at End of Life',

  QTY_DIVERTED_MECHANICAL_RECYCLING: 'Quantity Mechanical Recycling',
  QTY_DIVERTED_CHEMICAL_RECYCLING: 'Quantity Chemical Recycling',
  QTY_DIVERTED_PROCESSING_INTO_CHEMICALS_FUELS:
    'Quantity Processing into Chemicals/Fuels',
  QTY_DIVERTED_COMPOSTING: 'Quantity Composting',
  QTY_DIVERTED_DIRECT_REUSE: 'Quantity Direct Reuse',
  QTY_DIVERTED_REFURBISHMENT: 'Quantity Refurbishment',
  QTY_DIVERTED_REMANUFACTURING: 'Quantity Remanufacturing',
  QTY_DIVERTED_REPAIR: 'Quantity Repair',
  QTY_DIVERTED_INCINERATION_INDUSTRIAL_PROCESSES:
    'Quantity Incineration (Industrial Processes)',
  QTY_DIVERTED_INCINERATION_WITH_ENERGY_RECOVERY:
    'Quantity Incineration with Energy Recovery',

  QTY_FINAL_DISPOSAL_INCINERATION_NO_ENERGY:
    'Quantity Incineration (No Energy)',
  QTY_FINAL_DISPOSAL_LANDFILL: 'Quantity Landfill',

  QTY_ALBERTA: 'Quantity Alberta',
  QTY_BRITISH_COLUMBIA: 'Quantity British Columbia',
  QTY_MANITOBA: 'Quantity Manitoba',
  QTY_NEW_BRUNSWICK: 'Quantity New Brunswick',
  QTY_NEWFOUNDLAND_AND_LABRADOR: 'Quantity Newfoundland and Labrador',
  QTY_NORTHWEST_TERRITORIES: 'Quantity Northwest Territories',
  QTY_NOVA_SCOTIA: 'Quantity Nova Scotia',
  QTY_NUNAVUT: 'Quantity Nunavut',
  QTY_ONTARIO: 'Quantity Ontario',
  QTY_PRINCE_EDWARD_ISLAND: 'Quantity Prince Edward Island',
  QTY_QUEBEC: 'Quantity Quebec',
  QTY_SASKATCHEWAN: 'Quantity Saskatchewan',
  QTY_YUKON: 'Quantity Yukon',

  QTY_MANUFACTURED_CANADA: 'Quantity Manufactured in Canada',
  QTY_MECHANICAL_RECYCLING: 'Quantity Mechanical Recycling',
  QTY_CHEMICAL_RECYCLING: 'Quantity Chemical Recycling',
  QTY_PROCESSING_INTO_CHEMICALS_FUELS:
    'Quantity Processing into Chemicals/Fuels',
  QTY_COMPOSTING: 'Quantity Composting',
  QTY_DIRECT_REUSE: 'Quantity Direct Reuse',
  QTY_REFURBISHMENT: 'Quantity Refurbishment',
  QTY_REMANUFACTURING: 'Quantity Remanufacturing',
  QTY_REPAIR: 'Quantity Repair',
  QTY_INCINERATION_INDUSTRIAL_PROCESSES:
    'Quantity Incineration (Industrial Processes)',
  QTY_INCINERATION_WITH_ENERGY_RECOVERY:
    'Quantity Incineration with Energy Recovery',
  QTY_INCINERATION_NO_ENERGY: 'Quantity Incineration (No Energy)',
  QTY_LANDFILL: 'Quantity Landfill',
} as const

export const FPR_QUANTITY_KEYS = [
  'qtyManufactured',
  'qtyImported',
  'qtyPlacedOnMarket',
  'qtyAlberta',
  'qtyBritishColumbia',
  'qtyManitoba',
  'qtyNewBrunswick',
  'qtyNewfoundlandAndLabrador',
  'qtyNovaScotia',
  'qtyOntario',
  'qtyPrinceEdwardIsland',
  'qtyQuebec',
  'qtySaskatchewan',
  'qtyNorthwestTerritories',
  'qtyNunavut',
  'qtyYukon',
  'qtyWasteGeneratedAtPremises',
  'qtyCollectedAtEndOfLife',
  'qtyDivertedDirectReuse',
  'qtyDivertedRefurbishment',
  'qtyDivertedRepair',
  'qtyDivertedRemanufacturing',
  'qtyDivertedMechanicalRecycling',
  'qtyDivertedChemicalRecycling',
  'qtyDivertedProcessingIntoChemicalsFuels',
  'qtyDivertedComposting',
  'qtyDivertedIncinerationWithEnergyRecovery',
  'qtyDivertedIncinerationIndustrialProcesses',
  'qtyFinalDisposalIncinerationNoEnergy',
  'qtyFinalDisposalLandfill',
] as const

export type FprQuantityKey = (typeof FPR_QUANTITY_KEYS)[number]
